import { createSlice } from '@reduxjs/toolkit';

let initialState = {
  deepKYCStatus: null,
  sanctionsStatus: null,
  additionalInfo: null,
  isUserVerified: false
};

const investor = createSlice({
  name: 'investorReducer',
  initialState,
  reducers: {
    resetInvestor(state, action) {
      state = initialState;
    },
    setInvestor(state, action) {
      for (const [key, value] of Object.entries(action.payload)) {
        state[key] = value;
      }
    },
    setVerifiedEmail(state, action) {
      state.verifiedEmail = action.payload;
    },
    setCitizenship(state, action) {
      state.citizenship = action.payload;
    },
    setAdditionalInfo(state, action) {
      state.additionalInfo = action.payload;
    },
    setIsUserVerified(state, action) {
      state.isUserVerified = action.payload;
    }
  }
});

export const {
  resetInvestor,
  setInvestor,
  setVerifiedEmail,
  setCitizenship,
  setAdditionalInfo,
  setIsUserVerified
} = investor.actions;

export default investor.reducer;
